import classNames from 'classnames';
import { ChampionshipListItem } from 'modules/championship/domain/interfaces/championship-list-item';
import EmptyMessage from 'modules/championship/ui/components/empty-message';
import ChampionshipCard from 'modules/championship/ui/components/championship-card';
import * as S from 'modules/championship/ui/components/championships-body/styles';
import { ChampionshipsBodySkeleton } from 'modules/championship/ui/components/championships-body/championships-body-skeleton';
import React from 'react';
import UDPagination from 'ud-ui/components/pagination';
import { ChampionshipEncoded } from 'modules/championship/domain/interfaces/championship-encoded';

type ChampionshipsBodyProps = {
  filters: any;
  championships: ChampionshipListItem[];
  pages: number;
  onDetail: (id: ChampionshipEncoded['id']) => any;
  onPageChange: (page: number) => any;
  onResetFilters: () => void;
  isLoading?: boolean;
};

export const ChampionshipsBody = (props: ChampionshipsBodyProps) => {
  const { filters, championships, pages, onDetail, onPageChange, onResetFilters, isLoading } = props;
  const isEmpty = !championships.length;
  const isFilterActive = Boolean(filters.search) || filters.year != null;

  if (isLoading) {
    return <ChampionshipsBodySkeleton resultsOnPage={filters.perPage} className={'relative z-1'} />;
  }

  return (
    <>
      <S.ListContainer
        className={classNames('relative z-1 flex w-full flex-col px-6', {
          empty: isEmpty,
        })}
      >
        <div className="grid grid-cols-12 gap-3">
          {championships.map((championship) => (
            <div className="col-span-4" key={championship.id}>
              <ChampionshipCard
                key={championship.id}
                championship={championship}
                containerProps={{ className: 'item' }}
                onClickCard={onDetail}
              />
            </div>
          ))}
        </div>
        {isEmpty && <EmptyMessage className={'flex-center flex-1'} isFilterActive={isFilterActive} onResetFilters={onResetFilters} />}
      </S.ListContainer>

      {!isEmpty && (
        <UDPagination
          className="relative z-1 my-8 justify-start px-6"
          pages={pages}
          currentPage={filters.page}
          onPageChange={onPageChange}
        />
      )}
    </>
  );
};
